
export const set_header = (main, sub) => ({
    type: 'SET_HEADER',
    main: main,
    sub: sub
});

